<!--
 * @Author: your name
 * @Date: 2021-06-26 16:38:14
 * @LastEditTime: 2023-09-06 10:20:06
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\AttrList\AttrNClock.vue
-->
<!--数字时钟-->

<template>
  <div class="attr-nclock">
    <div class="nclock-item flex-b-c">
      <span class="nclock-attr">{{$t('PE.Name')}}</span>
      <span>{{$t('PE.Digital')}}</span>
    </div>
    <div class="nclock-item flex-b-c">
      <span class="nclock-attr">{{$t('PE.DisplayMode')}}</span>
      <div style="width: 130px;">
        <el-checkbox v-model="media.ext_val_showDate">{{$t('PE.Data')}}</el-checkbox>
        <el-checkbox v-model="media.ext_val_showTime">{{$t('PE.Time')}}</el-checkbox>
        <el-checkbox v-model="media.ext_val_showLunar">{{$t('PE.ChineseCalendar')}}</el-checkbox>
        <el-checkbox v-model="media.ext_val_showWeek">{{$t('PE.Week')}}</el-checkbox>
      </div>
    </div>
    <div class="nclock-item flex-b-c" v-show="media.ext_val_showDate">
      <span class="nclock-attr">{{$t('PE.DateFormat')}}</span>
      <el-select
        v-model="media.ext_val_dateStyle"
        @change="styleChange"
        :placeholder="$t('basics.PleaseSelect')"
        size="mini"
        style="width:130px;"
      >
        <el-option v-for="item in fdate" :key="item.label" :label="item.label" :value="item.label"></el-option>
      </el-select>
    </div>
    <div class="nclock-item flex-b-c">
      <span class="nclock-attr">{{$t('PE.SelectTimeZone')}}</span>
      <el-select
        v-model="media.ext_val_tzLabel"
        @change="timelinesChange"
        :placeholder="$t('basics.PleaseSelect')"
        size="mini"
        style="width:130px;"
      >
        <el-option v-for="time in timelines" :key="time.label" :label="time.label" :value="time.label"></el-option>
      </el-select>
    </div>
    <div class="nclock-item flex-b-c">
      <span class="nclock-attr">{{$t('PE.DisplayUsage')}}</span>
      <el-radio-group v-model="media.ext_val_singleLine" style="width: 130px;" class="flex-b-c">
        <el-radio :label="true" style="margin-right: 12px;">{{$t('PE.ARow')}}</el-radio>
        <el-radio :label="false" style="margin-right: 12px;">{{$t('PE.MultiRow')}}</el-radio>
      </el-radio-group>
    </div>
    <div class="nclock-item flex-b-c">
      <span class="nclock-attr">{{$t('PE.FontFamily')}}</span>
      <div class="nclock-attr-child" style="height: 96px;">
        <el-select v-model="media.ext_val_family" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
          <el-option v-for="item in familys" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <div style="width:130px;">
          <set-font-size @setFontSize="setFontSize" :defaultSize="media.ext_val_textSize"></set-font-size>
        </div>
        <!-- <el-select v-model="media.ext_val_textSize" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
          <el-option v-for="item in fontSize" :key="item" :label="item+'px'" :value="item"></el-option>
        </el-select>-->
        <div class="flex-a-c">
          <el-color-picker
            class="font-color-picker"
            v-model="media.ext_val_backgroundColor"
            size="mini"
            :show-alpha="true"
            :title="$t('PE.BackgroundColor')"
          ></el-color-picker>
          <!-- <span>{{$t('PE.Font')}}</span> -->
          <el-color-picker
            class="font-color-picker"
            v-model="media.ext_val_textColor"
            size="mini"
            :show-alpha="true"
            :title="$t('PE.FontColor')"
          ></el-color-picker>
        </div>
      </div>
    </div>
    <div class="nclock-item flex-b-c">
      <span class="nclock-attr">{{$t('PE.EnterTheAnimation')}}</span>
      <el-select v-model="media.ext_val_anim" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
        <el-option v-for="item in animations" :key="item.id" :label="$t(item.i18n)" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="nclock-item flex-b-c">
      <span class="nclock-attr">{{$t('PE.TheEntryTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_enterTime" :min="1" size="mini"></el-input-number>
    </div>
    <div class="nclock-item flex-b-c">
      <span class="nclock-attr">{{$t('PE.PlayTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_duration" :min="1" :label="$t('PE.Describe')" size="mini"></el-input-number>
    </div>
  </div>
</template>

<script>
import timelines from '@static/data/timezones.json';
import fdate from '@static/data/fdate.json';
import familys from '@static/data/familys.json';
// import fontSize from '@static/data/fontSize.js';
import SetFontSize from './children/SetFontSize';
import animations from '../../scripts/animations';
export default {
  name: "AttrNClock",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      animations,
      timelines,
      fdate,
      familys,
      // fontSize
    }
  },
  mounted() {
    // console.log(this.media);
  },
  methods: {
    styleChange(val) {
      this.media.ext_val_style = val;
    },
    timelinesChange(val) {
      let timelinesItem = this.timelines.find((time) => time.label === val);
      this.media.ext_val_tzId = timelinesItem.id;
      this.media.ext_val_tzCount = timelinesItem.tzCount;
    },
    setFontSize(val) {
      if (typeof (val) === "number") {
        this.media.ext_val_textSize = val;
      }
    },
  },
  components: {
    SetFontSize
  }
}
</script>

<style lang="scss" scoped>
.attr-nclock {
  padding-right: 4px;
  .nclock-item {
    min-height: 36px;
    margin: 8px 0px;
    .nclock-attr {
      width: 100px;
      font-family: "Times New Roman";
      font-weight: normal;
      font-stretch: normal;
      color: #617883;
    }
    .nclock-attr-child {
      width: 130px;
      height: 64px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      span {
        color: #617883;
        font-size: 14px;
      }
    }
  }
  .el-checkbox {
    margin-right: 12px;
  }
}
</style>